<div class="dialog-container">

  <!-- Cabeçalho fixo -->
  <div class="dialog-header">
    <h2 class="dialog-title">
      {{ tela === 'associar'
          ? (isSaida ? 'Associar Conta a Pagar' : 'Associar Movimentação')
          : 'Revisar Valores' }}
    </h2>
  </div>

  <!-- Card do extrato: fixo -->
  <div class="dialog-extrato">
    <div class="extrato-card">
      <div class="extrato-row">
        <span class="extrato-label">Data</span>
        <span class="extrato-value">{{ data.dataTransacao | date:'dd/MM/yyyy' }}</span>
      </div>
      <div class="extrato-row">
        <span class="extrato-label">Descrição</span>
        <span class="extrato-value">{{ data.memo || '—' }}</span>
      </div>
      <div class="extrato-row">
        <span class="extrato-label">Valor</span>
        <span class="extrato-value fw-bold"
            [class.entrada]="!isSaida"
            [class.saida]="isSaida">
          {{ isSaida ? '-' : '+' }} {{ valorExtrato | abnt:'preco' }}
        </span>
      </div>
    </div>
  </div>

  <!-- ── Tela: associar ──────────────────────────────────────────────── -->
  @if (tela === 'associar') {
  <div class="dialog-body associar-tela" [formGroup]="model">

    <!-- Filtros fixos dentro do body -->
    <div class="dialog-fixed">

      <div class="row">

        <!-- Botão período -->
        <div class="col-6 col-sm-4">
          <button #periodoMenuTrigger="matMenuTrigger" mat-stroked-button type="button" class="btn-periodo"
            [matMenuTriggerFor]="periodoMenu" (menuOpened)="prepararPeriodoIntervalo()"
            [class.btn-periodo--ativo]="periodoSelecionado !== periodoBuscaEnum.Ultimos30Dias">
            {{ periodoLabel }}
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>

          <mat-menu #periodoMenu="matMenu" class="periodo-custom-menu" (closed)="onPeriodoMenuClosed()">
            <div class="periodo-menu-content">
              <div>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(periodoBuscaEnum.Hoje); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="periodoSelecionado === periodoBuscaEnum.Hoje">
                  <span>hoje</span>
                  @if (periodoSelecionado === periodoBuscaEnum.Hoje) { <mat-icon>check</mat-icon> }
                </button>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(periodoBuscaEnum.DaSemana); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="periodoSelecionado === periodoBuscaEnum.DaSemana">
                  <span>desta semana</span>
                  @if (periodoSelecionado === periodoBuscaEnum.DaSemana) { <mat-icon>check</mat-icon> }
                </button>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(periodoBuscaEnum.DoMes); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="periodoSelecionado === periodoBuscaEnum.DoMes">
                  <span>do mês</span>
                  @if (periodoSelecionado === periodoBuscaEnum.DoMes) { <mat-icon>check</mat-icon> }
                </button>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(periodoBuscaEnum.Ultimos30Dias); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="periodoSelecionado === periodoBuscaEnum.Ultimos30Dias">
                  <span>últimos 30 dias</span>
                  @if (periodoSelecionado === periodoBuscaEnum.Ultimos30Dias) { <mat-icon>check</mat-icon> }
                </button>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(periodoBuscaEnum.DoIntervalo); $event.stopPropagation()"
                  [class.periodo-item-selecionado]="periodoSelecionado === periodoBuscaEnum.DoIntervalo">
                  <span>do intervalo</span>
                  @if (periodoSelecionado === periodoBuscaEnum.DoIntervalo) { <mat-icon>check</mat-icon> }
                </button>

                @if (periodoSelecionado === periodoBuscaEnum.DoIntervalo) {
                <div class="periodo-intervalo-fields" (click)="$event.stopPropagation()">
                  <mat-form-field appearance="outline">
                    <mat-label>De</mat-label>
                    <input matInput [matDatepicker]="pickerDe" placeholder="DD/MM/AAAA"
                      (input)="onDateInput($event)" formControlName="dataDe">
                    <mat-datepicker-toggle matSuffix [for]="pickerDe"></mat-datepicker-toggle>
                    <mat-datepicker #pickerDe></mat-datepicker>
                    @if (model.get('dataDe')?.hasError('required')) {
                    <mat-error>Data inicial obrigatória</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Até</mat-label>
                    <input matInput [matDatepicker]="pickerAte" placeholder="DD/MM/AAAA"
                      (input)="onDateInput($event)" formControlName="dataAte">
                    <mat-datepicker-toggle matSuffix [for]="pickerAte"></mat-datepicker-toggle>
                    <mat-datepicker #pickerAte></mat-datepicker>
                    @if (model.get('dataAte')?.hasError('required')) {
                    <mat-error>Data final obrigatória</mat-error>
                    }
                    @if (model.get('dataAte')?.hasError('dataInvalida')) {
                    <mat-error>Data final menor que inicial</mat-error>
                    }
                    @if (model.get('dataAte')?.hasError('intervaloExcedido')) {
                    <mat-error>Intervalo máx. de {{ limiteMaxDias }} dias</mat-error>
                    }
                  </mat-form-field>
                  <div class="periodo-intervalo-actions">
                    <button type="button" mat-button class="btn-secondary"
                      (click)="cancelarPeriodoIntervalo(periodoMenuTrigger)">Cancelar</button>
                    <button type="button" mat-flat-button class="btn-primary"
                      (click)="aplicarPeriodo(periodoMenuTrigger)">Aplicar</button>
                  </div>
                </div>
                }
              </div>
            </div>
          </mat-menu>
        </div>

        <!-- Tipo -->
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-6 col-sm-8">
          <mat-label>Tipo</mat-label>
          <mat-select formControlName="tipo">
            @for (t of tiposDisponiveis; track t.value) {
            <mat-option [value]="t.value">{{ t.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <!-- Pesquisa -->
        <mat-form-field appearance="outline" class="col-12">
          <mat-label>Pesquisar</mat-label>
          <input matInput formControlName="busca" (keyup.enter)="carregarCandidatos()">
          <mat-icon matSuffix style="cursor:pointer" (click)="carregarCandidatos()">search</mat-icon>
        </mat-form-field>

      </div>

      <!-- Limpar seleção -->
      @if (temSelecao) {
      <div class="limpar-selecao-wrapper">
        <button mat-button (click)="limparSelecao()">
          Limpar seleção
        </button>
      </div>
      }

    </div><!-- /dialog-fixed -->

    <!-- Lista scrollável -->
    <div class="lista-container">
      @if (isCarregandoCandidatos) {
      <div class="text-center py-4">
        <mat-spinner diameter="36" class="mx-auto"></mat-spinner>
      </div>
      } @else {

        @if (isSaida) {
          @if (parcelasCandidatas.length === 0) {
          <div class="text-center py-4">Nenhuma Conta a Pagar em aberto encontrada no período.</div>
          }
          @for (p of parcelasCandidatas; track p.idContasPagarParcela) {
          <div class="item-card mb-2"
            [class.item-card--selecionado]="isCpSelecionado(p.idContasPagarParcela)"
            (click)="toggleCp(p.idContasPagarParcela)">
            <div class="item-check">
              <mat-checkbox color="primary"
                [checked]="isCpSelecionado(p.idContasPagarParcela)"
                (change)="toggleCp(p.idContasPagarParcela)"
                (click)="$event.stopPropagation()"></mat-checkbox>
            </div>
            <div class="item-body">
              <div class="item-row-top">
                <span class="status-badge badge-cinza">Conta a Pagar</span>
                <span class="item-data">{{ p.datetimeVencimento | date:'dd/MM/yyyy' }}</span>
              </div>
              <div class="item-descricao">{{ p.descricao }}</div>
              @if (p.nomeFornecedor) {
              <div class="item-entidade">{{ p.nomeFornecedor }}</div>
              }
            </div>
            <div class="item-valor">{{ p.valor | abnt:'preco' }}</div>
          </div>
          }
        } @else {
          @if (movsCandidatas.length === 0) {
          <div class="text-center py-4">Nenhuma movimentação disponível para vincular no período.</div>
          }
          @for (m of movsCandidatas; track m.idMovimentacao) {
          <div class="item-card mb-2"
            [class.item-card--selecionado]="isMovSelecionada(m.idMovimentacao)"
            (click)="toggleMov(m.idMovimentacao)">
            <div class="item-check">
              <mat-checkbox color="primary"
                [checked]="isMovSelecionada(m.idMovimentacao)"
                (change)="toggleMov(m.idMovimentacao)"
                (click)="$event.stopPropagation()"></mat-checkbox>
            </div>
            <div class="item-body">
              <div class="item-row-top">
                <span class="status-badge badge-cinza">Movimentação</span>
                <span class="item-data">{{ m.dataMovimentacao | date:'dd/MM/yyyy' }}</span>
              </div>
              <div class="item-descricao">{{ m.descricao || 'Sem descrição' }}</div>
            </div>
            <div class="item-valor">{{ m.valor | abnt:'preco' }}</div>
          </div>
          }
        }

        <!-- Ver Mais -->
        @if (!isCarregandoCandidatos && (parcelasCandidatas.length > 0 || movsCandidatas.length > 0)) {
        <div class="text-center mt-2">
          <button mat-button [disabled]="!_temMais || isLoadingMais" (click)="proximaPagina()">
            @if (isLoadingMais) {
            <mat-spinner diameter="20"></mat-spinner>
            } @else {
            <span class="material-symbols-outlined">expand_more</span>
            Ver Mais
            }
          </button>
        </div>
        }

      }
    </div><!-- /lista-container -->

  </div>
  }

  <!-- ── Tela: revisar valores ───────────────────────────────────────── -->
  @if (tela === 'revisar') {
  <div class="dialog-body revisar-tela">

    <!-- Alert -->
    @if (Math.abs(diferencaRevisar) >= 0.01) {
    <app-alert-card type="warning"
      [title]="'Corrija a diferença de ' + (diferencaRevisar | abnt:'preco')"
      [closable]="false" class="mb-3">
      O valor está diferente do extrato. Ajuste os campos abaixo para que o valor final coincida.
    </app-alert-card>
    } @else {
    <app-alert-card type="success" title="Valores conferem!" [closable]="false" class="mb-3">
      A soma ajustada é igual ao valor do extrato.
    </app-alert-card>
    }

    <!-- Cards dos itens selecionados -->
    @if (isSaida) {
      @for (p of parcelasSelecionadas; track p.idContasPagarParcela; let i = $index) {
      <div class="item-card mb-2" [formGroup]="formAt(i)">
        <div class="item-top">
          <div class="item-top-left">
            <span class="status-badge badge-cinza">Conta a Pagar</span>
            <span class="item-data">{{ p.datetimeVencimento | date:'dd/MM/yyyy' }}</span>
          </div>
          <div class="item-valor-aberto">
            <span class="enc-label">Vlr. Aberto</span>
            <span class="enc-value">{{ p.valor | abnt:'preco' }}</span>
          </div>
        </div>
        <div class="item-main-info">
          <div class="item-descricao">{{ p.descricao }}</div>
          @if (p.nomeFornecedor) {
          <div class="item-entidade">{{ p.nomeFornecedor }}</div>
          }
        </div>
        <div class="encargos-grid">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="enc-form-field">
            <mat-label>Juros</mat-label>
            <input matInput [currencyMask]="currencyMask" formControlName="valorJurosPrevisto">
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="enc-form-field">
            <mat-label>Multa</mat-label>
            <input matInput [currencyMask]="currencyMask" formControlName="valorMultaPrevisto">
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="enc-form-field">
            <mat-label>Acréscimo</mat-label>
            <input matInput [currencyMask]="currencyMask" formControlName="valorAcrescimoPrevisto">
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="enc-form-field">
            <mat-label>Desconto</mat-label>
            <input matInput [currencyMask]="currencyMask" formControlName="valorDescontoPrevisto">
          </mat-form-field>
        </div>
        <div class="item-footer">
          <span class="enc-label">Valor final</span>
          <span class="valor-final fw-bold">{{ valorFinalItem(i) | abnt:'preco' }}</span>
        </div>
      </div>
      }
    } @else {
      @for (m of movimentacoesSelecionadas; track m.idMovimentacao; let i = $index) {
      <div class="item-card mb-2" [formGroup]="formAt(i)">
        <div class="item-top">
          <div class="item-top-left">
            <span class="status-badge badge-cinza">Movimentação</span>
            <span class="item-data">{{ m.dataMovimentacao | date:'dd/MM/yyyy' }}</span>
          </div>
          <div class="item-valor-aberto">
            <span class="enc-label">Vlr. Aberto</span>
            <span class="enc-value">{{ m.valor | abnt:'preco' }}</span>
          </div>
        </div>
        <div class="item-main-info">
          <div class="item-descricao">{{ m.descricao || 'Sem descrição' }}</div>
        </div>
        <div class="encargos-grid">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="enc-form-field enc-form-field--valor">
            <mat-label>Novo Valor</mat-label>
            <input matInput [currencyMask]="currencyMask" formControlName="novoValor">
          </mat-form-field>
        </div>
        <div class="item-footer">
          <span class="enc-label">Valor final</span>
          <span class="valor-final fw-bold">{{ valorFinalItem(i) | abnt:'preco' }}</span>
        </div>
      </div>
      }
    }

  </div>
  }

  <!-- ── Footer fixo ─────────────────────────────────────────────────── -->
  <div class="dialog-footer">

    @if (tela === 'associar') {
    <div class="totais">
      <div class="footer-item">
        <span class="footer-label">Total extrato</span>
        <span class="footer-value">{{ valorExtrato | abnt:'preco' }}</span>
      </div>
      <div class="footer-item">
        <span class="footer-label">Valor selecionado</span>
        <span class="footer-value" [class.footer-valor-ok]="podeConciliar">
          {{ valorSelecionado | abnt:'preco' }}
        </span>
      </div>
      <div class="footer-item">
        <span class="footer-label">Diferença</span>
        <span class="footer-value" [class.footer-valor-falta]="Math.abs(diferenca) >= 0.01">
          {{ diferenca | abnt:'preco' }}
        </span>
      </div>
    </div>
    <div class="botoes">
      <button mat-stroked-button class="btn-secondary"
        [disabled]="!podeRevisar || isConciliando"
        (click)="onIrParaRevisar()">
        Revisar valores
      </button>
      <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
      <span [matTooltip]="!podeConciliar && temSelecao && !isConciliando ? 'Valores diferem — use Revisar valores' : ''"
            matTooltipPosition="above">
        <button mat-flat-button class="btn-primary"
          [disabled]="!podeConciliar || isConciliando"
          (click)="confirmarDireto()">
          @if (isConciliando) {
            <mat-spinner diameter="18" class="spinner-inline"></mat-spinner>
          } @else {
            Confirmar
          }
        </button>
      </span>
    </div>
    }

    @if (tela === 'revisar') {
    <div class="totais">
      <div class="footer-item">
        <span class="footer-label">Total extrato</span>
        <span class="footer-value">{{ valorExtrato | abnt:'preco' }}</span>
      </div>
      <div class="footer-item">
        <span class="footer-label">Valor ajustado</span>
        <span class="footer-value" [class.footer-valor-ok]="podeConciliarRevisar">
          {{ valorComAjuste | abnt:'preco' }}
        </span>
      </div>
      <div class="footer-item">
        <span class="footer-label">Diferença</span>
        <span class="footer-value" [class.footer-valor-falta]="Math.abs(diferencaRevisar) >= 0.01">
          {{ diferencaRevisar | abnt:'preco' }}
        </span>
      </div>
    </div>
    <div class="botoes">
      <button mat-stroked-button class="btn-secondary"
        [disabled]="isConciliando"
        (click)="voltarParaAssociar()">
        <mat-icon>arrow_back</mat-icon> Voltar
      </button>
      <span [matTooltip]="!podeConciliarRevisar && !isConciliando ? 'Corrija a diferença de ' + (diferencaRevisar | abnt:'preco') : ''"
            matTooltipPosition="above">
        <button mat-flat-button class="btn-primary"
          [disabled]="!podeConciliarRevisar || isConciliando"
          (click)="confirmarRevisar()">
          @if (isConciliando) {
            <mat-spinner diameter="18" class="spinner-inline"></mat-spinner>
          } @else {
            Confirmar
          }
        </button>
      </span>
    </div>
    }

  </div>

</div>
